import "./App.css";
import { history } from "./history";
import { Router, Switch, Route } from "react-router-dom";
import { Helmet } from "react-helmet";

import React, { useState, lazy, Suspense, createContext } from "react";
import Header from "./components/Header";
import Sidebar from "./components/SideBar/Sidebar";
// import { DieselRequestList } from "./components/FuelReports/dieselRequestList";
import ConvertpdfPage from "./components/VehicleManagement/ConvertpdfPage";
// import SubscriptionList from "./components/Subscription_master/SubscriptionList";
// import VehicleCertificate from "./components/VehicleManagement/VehicleCertificate";
// import ViewCertificatesData from "./components/VehicleManagement/ViewCertificatesData";
// import { PrivateRoute } from './route/privateRoute';
import { createTheme, ThemeProvider } from "@material-ui/core/styles";
import { ThemeContext } from "@emotion/react";

const Login = lazy(() => import("./components/Login"));
const UserList = lazy(() => import("./components/UserManagement/userList"));
const AddUser = lazy(() => import("./components/UserManagement/addUser"));
const Users = lazy(() => import("./components/UserManagement/viewUser"));
const SubUserList = lazy(() =>
  import("./components/UserManagement/SubUserManagement/subUserList")
);
const AddSubUser = lazy(() =>
  import("./components/UserManagement/SubUserManagement/addSubUser")
);
const VehicleCertificate = lazy(() =>
  import("./components/VehicleManagement/VehicleCertificate")
);
const SubUsers = lazy(() =>
  import("./components/UserManagement/SubUserManagement/viewSubUser")
);
const CompanyList = lazy(() =>
  import("./components/CompanyManagement/companyList")
);
const AddCompany = lazy(() =>
  import("./components/CompanyManagement/addCompany")
);
const AddSite = lazy(() => import("./components/Site/addSite"));
const VehicleList = lazy(() =>
  import("./components/VehicleManagement/vehicleList")
);
const AddVehicle = lazy(() =>
  import("./components/VehicleManagement/addVehicle")
);
const VendorList = lazy(() =>
  import("./components/VendorManagement/vendorList")
);
const AddVendor = lazy(() => import("./components/VendorManagement/addVendor"));
const Vehicles = lazy(() =>
  import("./components/VehicleManagement/viewVehicle")
);

const KycMaster = lazy(() => import("../src/components/KycMaster/KycMaster"));
const Vendors = lazy(() => import("./components/VendorManagement/viewVendor"));
const RouteList = lazy(() => import("./components/RouteManagement/routeList"));
const AddRoute = lazy(() => import("./components/RouteManagement/addRoute"));
const ViewRoute = lazy(() => import("./components/RouteManagement/viewRoute"));
const TripList = lazy(() => import("./components/TripManagement/tripList"));
const ViewTrip = lazy(() => import("./components/TripManagement/viewTrip"));
const AddTrip = lazy(() => import("./components/TripManagement/addTrip"));
const Reports = lazy(() => import("./components/Reports/report"));
const SiteManagement = lazy(() => import("./components/Site/siteManagement"));
const ViewUser = lazy(() => import("./components/Site/viewUser"));
const LiveTracking = lazy(() => import("./components/Tracking/live"));
const HistoryTracking = lazy(() => import("./components/Tracking/history"));
const Dashboard = lazy(() => {
  window.open("/", "_self");
  import("./components/Dashboard/dashboard");
});

const AllReportPage = lazy(() =>
  import("./components/ReportsGps/AllReportPage")
);
// const FuelReport = lazy(() => import("./components/FuelReports/report"));
// // const FuelDashboard = lazy(() => import("./components/FuelReports/dashboard"));
// const FuelDashboard = lazy(() =>
//   import("./components/FuelReports/fuelDashboard")
// );
const KMLView = lazy(() => import("./components/kmlFile/index"));
const Alerts = lazy(() => import("./components/Alerts/index"));
const SummaryReportPage = lazy(() =>
  import("./components/ReportsGps/SummaryReportPage")
);
const MovementReportPage = lazy(() =>
  import("./components/ReportsGps/Movement")
);
const StopReportPage = lazy(() =>
  import("./components/ReportsGps/StopReportPage")
);
const tripMap = lazy(() => import("./components/TripManagement/tripMaps"));
const ReportMapDetails = lazy(() =>
  import("./components/Reports/reportMapDetails")
);
// const FuelVehicleDetail = lazy(() =>
//   import("./components/FuelReports/fuelVehicleDetail")
// );
// const SensorWirecut = lazy(() =>
//   import("./components/FuelReports/SensorWirecut")
// );
const NotificationConfiguration = lazy(() =>
  import("./components/ConfigureManagement/Notification_Configuration")
);
const AddNotification = lazy(() =>
  import(
    "./components/ConfigureManagement/add_notication/Add_Notification_Configuration"
  )
);
// const Dieselissue = lazy(() => import("./components/FuelReports/Diesel_issue"));
// const Requste = lazy(() => import("./components/FuelReports/Requester"));
const RoleList = lazy(() => import("./components/SideBar/RoleList/Rolelist"));
const VehicleActivation = lazy(() =>
  import("./components/VehicleActivation/VehicleActivation")
);
const SubscriptionList = lazy(() =>
  import("./components/Subscription_master/SubscriptionList")
);
const DealerLedgerList = lazy(() =>
  import("./components/DealerLedger/dealerLedgerList")
);
const DealerDetails = lazy(() =>
  import("./components/DealerLedger/dealerDetails")
);
// const DealerDetails = lazy(() =>
//   import("./components/Activation_Renewal/DealerDetails")
// );
const ActivationRenewalList = lazy(() =>
  import("./components/Activation_Renewal/activatiRenewalList")
);
const AddActivationRequest = lazy(() =>
  import("./components/Activation_Renewal/addActivationrenewalRequest")
);
const ActivationByidDetails = lazy(() =>
  import("./components/Activation_Renewal/activationByidDetails")
);
const UpdateDate = lazy(() =>
  import("./components/Activation_Renewal/updateDate")
);
const VehicleDashboard = lazy(() =>
  import("./components/VehicleDetailsDashboard/Dashboard")
);
export const themeContext = createContext({ color: "#542f85" });
console.log(themeContext);
const color =
  (localStorage.getItem("config") &&
    JSON.parse(localStorage.getItem("config")) &&
    JSON.parse(localStorage.getItem("config")).datas &&
    JSON.parse(JSON.parse(localStorage.getItem("config")).datas)?.color) ||
  "#542f85";

const dynamicFaviconUrl =
  localStorage.getItem("config") &&
  JSON.parse(localStorage.getItem("config")).logoUrl;

// const dynamicFaviconUrl="https://eclvts.com/resources/psdn.jpeg"
console.log(dynamicFaviconUrl);
const darkenColor = (hexColor, percent) => {
  debugger;
  // Parse hex color to RGB
  // Remove the hash if it's present
  const hex = hexColor.replace(/^#/, "");

  // Parse the hex values for each color component
  const bigint = parseInt(hex, 16);
  const r = (bigint >> 16) & 255;
  const g = (bigint >> 8) & 255;
  const b = bigint & 255;

  // Return the RGB values as an object
  // return { r, g, b };

  // Darken the color (adjust the percentage as needed)
  const darkenAmount = 1 - percent / 100;
  const darkenedColor = `#${Math.round(r * darkenAmount).toString(
    16
  )}${Math.round(g * darkenAmount).toString(16)}${Math.round(
    b * darkenAmount
  ).toString(16)}`;
  console.log(darkenedColor);
  return darkenedColor;
};
console.log(color && color);
const theme = createTheme({
  overrides: {
    // Style sheet name ⚛️
    MuiButton: {
      // Name of the rule
      contained: {
        // Some CSS
        color: "white",
        backgroundColor: color || "#542f85",
        "&:hover": {
          backgroundColor: color ? darkenColor(color, 95) : "#542f85",
        },
      },
    },
  },
});

function App() {
  const [themeColor, setThemeColor] = useState(color || "#47296b");

  // componentDidMount() {
  //   // window.location.hostname=='ioclfleet'?document.title = "IOCL":document.title = "NKC"
  // }

  return (
    <main className="App">
      {/* <Helmet>
        <link rel="icon" href={dynamicFaviconUrl} type="image/x-icon" />
      </Helmet> */}
      <themeContext.Provider value={{ color: themeColor }}>
        <ThemeProvider theme={theme}>
          <Router history={history}>
            {window.location.pathname !== "/" &&
              window.location.pathname !== "/alerts" &&
              window.location.pathname.split("/")[1] !== "VehicleCertificate" &&
              window.location.pathname !== "/ViewCertificatesData" && (
                <>
                  <Header />
                  <Sidebar />
                </>
              )}

            <Suspense fallback={<div>Loading</div>}>
              <Switch>
                <Route exact path="/" component={Login} />
                <Route exact path="/userlist" component={UserList} />
                <Route exact path="/adduser" component={AddUser} />
                <Route exact path="/users/:id?" component={Users} />
                <Route exact path="/subuserlist" component={SubUserList} />
                <Route exact path="/addsubuser" component={AddSubUser} />
                <Route exact path="/subusers/:id" component={SubUsers} />
                <Route exact path="/companylist" component={CompanyList} />
                <Route exact path="/addcompany" component={AddCompany} />
                <Route exact path="/vehiclelist" component={VehicleList} />
                <Route exact path="/addvehicle" component={AddVehicle} />
                <Route exact path="/vehicles/:id?" component={Vehicles} />
                <Route exact path="/transporters/:id?" component={Vendors} />
                <Route exact path="/kycMaster" component={KycMaster} />
                <Route exact path="/transporterlist" component={VendorList} />
                <Route exact path="/addtransporter" component={AddVendor} />
                <Route exact path="/routelist" component={RouteList} />
                <Route exact path="/addroute" component={AddRoute} />
                <Route exact path="/routes/:id?" component={ViewRoute} />
                <Route exact path="/triplist" component={TripList} />
                <Route exact path="/addtrip" component={AddTrip} />
                <Route exact path="/trips/:id?" component={ViewTrip} />
                <Route exact path="/reports" component={Reports} />
                <Route exact path="/sitelist" component={SiteManagement} />
                <Route exact path="/viewUser/:id?" component={ViewUser} />
                <Route exact path="/site/:id?" component={AddSite} />
                <Route exact path="/addSite" component={AddSite} />
                <Route exact path="/live/:id?" component={LiveTracking} />
                <Route exact path="/history/:id?" component={HistoryTracking} />
                <Route exact path="/dashboard" component={Dashboard} />
                <Route exact path="/Reportsgps" component={AllReportPage} />
                {/* <Route exact path="/fuelReport" component={FuelReport} /> */}
                {/* <Route exact path="/fuelDashboard" component={FuelDashboard} /> */}
                <Route exact path="/kmlview" component={KMLView} />
                <Route exact path="/alerts" component={Alerts} />
                <Route exact path="/Summary" component={SummaryReportPage} />
                <Route exact path="/Movement" component={MovementReportPage} />
                <Route exact path="/Stoppage" component={StopReportPage} />
                <Route
                  exact
                  path="/reportDetails"
                  component={ReportMapDetails}
                />
                <Route exact path="/tripTrack/:id?" component={tripMap} />
                <Route exact path="/audit" component={Reports} />
                <Route exact path="/activeRoutes" component={Reports} />
                <Route exact path="/upTime" component={Reports} />
                <Route
                  exact
                  path="/VehicleCertificate/:certificateNo?"
                  component={VehicleCertificate}
                />
                {/* <Route
                exact
                path="/ViewCertificatesData"
                component={ViewCertificatesData}
              /> */}
                {/* <Route
                exact
                path="/fuelDetails/:id?"
                component={FuelVehicleDetail}
              /> */}
                <Route
                  exact
                  path="/notificationConfigure"
                  component={NotificationConfiguration}
                />
                <Route
                  exact
                  path="/addNotification"
                  component={AddNotification}
                />
                <Route
                  exact
                  path="/viewNotification/:id?"
                  component={AddNotification}
                />
                {/* <Route exact path="/SensorWirecut" component={SensorWirecut} /> */}
                {/* <Route exact path="/Diesel_issue" component={DieselRequestList} /> */}
                {/* {/ <Route exact path="/Requester" component={Requester} /> /} */}
                <Route exact path="/rolelist" component={RoleList} />
                <Route
                  exact
                  path="/VehicleActivation"
                  component={VehicleActivation}
                />
                <Route
                  exact
                  path="/SubscriptionMaster"
                  component={SubscriptionList}
                />
                <Route
                  exact
                  path="/dealerLedger"
                  component={DealerLedgerList}
                />
                <Route
                  exact
                  path="/dealerDetails/:id?"
                  component={DealerDetails}
                />
                <Route
                  exact
                  path="/activationRenewalList"
                  component={ActivationRenewalList}
                />
                <Route exact path="/updateDate" component={UpdateDate} />

                <Route
                  exact
                  path="/addNewRequest/:requestType"
                  component={AddActivationRequest}
                />
                <Route
                  exact
                  path="/ActivationByIdDetails/:id?"
                  component={ActivationByidDetails}
                />
                <Route exact path="/VehicleDashboard" component={VehicleDashboard} />
              </Switch>
            </Suspense>
          </Router>
        </ThemeProvider>
      </themeContext.Provider>
    </main>
  );
}
export default App;
